import Vue from 'vue'
import Router from 'vue-router'
import Global from '@/assets/js/global'

const Authority = ()=> import('@/views/Authority')
const MemberPurchase = ()=> import('@/views/MemberPurchase')
const PaySuccess = ()=> import('@/views/PaySuccess')
const Personal = ()=> import('@/views/Personal')
const AboutUs = ()=> import('@/views/AboutUs')
const ServiceProgress = ()=> import('@/views/ServiceProgress')
const FamilyMemberList = ()=> import('@/views/FamilyMemberList')
const Identify = ()=> import('@/views/Identify')
const MemberInfo = ()=> import('@/views/MemberInfo')
const PlanList = ()=> import('@/views/PlanList')
const PlanDetail = ()=> import('@/views/PlanDetail')
const AllPolicy = ()=> import('@/views/AllPolicy')
const PolicyDetail = ()=> import('@/views/PolicyDetail')
const FamilyInfo = ()=> import('@/views/FamilyInfo')
const Appointment = ()=> import('@/views/Appointment')
const Activity = ()=> import('@/components/Activity')

const List = ()=> import('@/components/List')
const Records = ()=> import('@/components/Records')
const Signin = ()=> import('@/components/Signin')





Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'memberPurchase',
      component: MemberPurchase,
      meta: {
        title: '会员购买'
      }
    },
    {
      path: '/Records',
      name: 'Records',
      component: Records,
      meta: {
        title: '奖励记录'
      }
    },
    {
      path: '/List',
      name: 'List',
      component: List,
      meta: {
        title: '荣誉榜单'
      }
    },
    {
      path: '/Activity',
      name: 'Activity',
      component: Activity,
      meta: {
        title: '活动抽奖'
      }
    },
    {
      path: '/Signin',
      name: 'Signin',
      component: Signin,
      meta: {
        title: '每日签到'
      }
    },
    {
      path: '/Appointment',
      name: 'Appointment',
      component: Appointment,
      meta: {
        title: '预约咨询'
      }
    },
    {
      path: '/authority',
      name: 'authority',
      component: Authority,
      meta: {
        title: '授权中'
      }
    },
    {
      path: '/paySuccess',
      name: 'paySuccess',
      component: PaySuccess,
      meta: {
        title: '购买成功'
      },
      props: {
        vip: 0
      }
    },
    {
      path: '/personal',
      name: 'personal',
      component: Personal,
      meta: {
        title: '个人中心'
      }
    },
    {
      path: '/aboutUs',
      name: 'aboutUs',
      component: AboutUs,
      meta: {
        title: '关于我们'
      }
    },
    {
      path: '/serviceProgress',
      name: 'serviceProgress',
      component: ServiceProgress,
      meta: {
        title: '服务进度'
      }
    },
    {
      path: '/familyMemberList',
      name: 'familyMemberList',
      component: FamilyMemberList,
      meta: {
        title: '家庭成员'
      }
    },
    {
      path: '/identify',
      name: 'identify',
      component: Identify,
      meta: {
        title: '认证'
      }
    },
    {
      path: '/memberInfo',
      name: 'memberInfo',
      component: MemberInfo,
      meta: {
        title: '成员信息'
      }
    },
    {
      path: '/planList',
      name: 'planList',
      component: PlanList,
      meta: {
        title: '全部方案'
      }
    },
    {
      path: '/planDetail',
      name: 'planDetail',
      component: PlanDetail,
      meta: {
        title: '方案详情'
      }
    },
    {
      path: '/allPolicy',
      name: 'allPolicy',
      component: AllPolicy,
      meta: {
        title: '全部保单'
      }
    },
    {
      path: '/policyDetail',
      name: 'policyDetail',
      component: PolicyDetail,
      meta: {
        title: '保单详情'
      }
    },
    {
      path: '/familyInfo',
      name: 'familyInfo',
      component: FamilyInfo,
      meta: {
        title: '家庭信息'
      }
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  //  第一次进入项目
  // console.log(Global.getCookie("token"))
  let token = Global.getCookie("token")
  if ( !token ){
    // console.log( to,' to.fullPath')
    if ( to.path != "/authority") {
      window.localStorage.setItem("beforeLoginUrl", to.fullPath)// 保存用户进入的url
      window.localStorage.setItem("adviser_id", to.query.adviser_id)// 保存用户进入的url
      if(to.query.s_evolution){
        window.localStorage.setItem("s_evolution", to.query.s_evolution)
      }
      next("/authority")
      return false;
    }
  } 
  next()
})

router.afterEach(() => {
  window.scrollTo(0,0)
})

export default router